module.exports = __webpack_public_path__ + "img/pohled_z_balkonu_2.fb9973d7.jpg";